// lib/geography/countries-and-regions.ts
var unitedStates = {
  name: "United States",
  abbreviation: "US",
  regionIdentifier: "State",
  regions: [
    { abbreviation: "AL", name: "Alabama" },
    { abbreviation: "AK", name: "Alaska" },
    { abbreviation: "AZ", name: "Arizona" },
    { abbreviation: "AR", name: "Arkansas" },
    { abbreviation: "CA", name: "California" },
    { abbreviation: "CO", name: "Colorado" },
    { abbreviation: "CT", name: "Connecticut" },
    { abbreviation: "DE", name: "Delaware" },
    { abbreviation: "DC", name: "District Of Columbia" },
    { abbreviation: "FL", name: "Florida" },
    { abbreviation: "GA", name: "Georgia" },
    { abbreviation: "HI", name: "Hawaii" },
    { abbreviation: "ID", name: "Idaho" },
    { abbreviation: "IL", name: "Illinois" },
    { abbreviation: "IN", name: "Indiana" },
    { abbreviation: "IA", name: "Iowa" },
    { abbreviation: "KS", name: "Kansas" },
    { abbreviation: "KY", name: "Kentucky" },
    { abbreviation: "LA", name: "Louisiana" },
    { abbreviation: "ME", name: "Maine" },
    { abbreviation: "MD", name: "Maryland" },
    { abbreviation: "MA", name: "Massachusetts" },
    { abbreviation: "MI", name: "Michigan" },
    { abbreviation: "MN", name: "Minnesota" },
    { abbreviation: "MS", name: "Mississippi" },
    { abbreviation: "MO", name: "Missouri" },
    { abbreviation: "MT", name: "Montana" },
    { abbreviation: "NE", name: "Nebraska" },
    { abbreviation: "NV", name: "Nevada" },
    { abbreviation: "NH", name: "New Hampshire" },
    { abbreviation: "NJ", name: "New Jersey" },
    { abbreviation: "NM", name: "New Mexico" },
    { abbreviation: "NY", name: "New York" },
    { abbreviation: "NC", name: "North Carolina" },
    { abbreviation: "ND", name: "North Dakota" },
    { abbreviation: "OH", name: "Ohio" },
    { abbreviation: "OK", name: "Oklahoma" },
    { abbreviation: "OR", name: "Oregon" },
    { abbreviation: "PA", name: "Pennsylvania" },
    { abbreviation: "RI", name: "Rhode Island" },
    { abbreviation: "SC", name: "South Carolina" },
    { abbreviation: "SD", name: "South Dakota" },
    { abbreviation: "TN", name: "Tennessee" },
    { abbreviation: "TX", name: "Texas" },
    { abbreviation: "UT", name: "Utah" },
    { abbreviation: "VT", name: "Vermont" },
    { abbreviation: "VA", name: "Virginia" },
    { abbreviation: "WA", name: "Washington" },
    { abbreviation: "WV", name: "West Virginia" },
    { abbreviation: "WI", name: "Wisconsin" },
    { abbreviation: "WY", name: "Wyoming" }
  ]
};
var canada = {
  name: "Canada",
  abbreviation: "CA",
  regionIdentifier: "Province",
  regions: [
    { abbreviation: "AB", name: "Alberta" },
    { abbreviation: "BC", name: "British Columbia" },
    { abbreviation: "MB", name: "Manitoba" },
    { abbreviation: "NB", name: "New Brunswick" },
    { abbreviation: "NL", name: "Newfoundland and Labrador" },
    { abbreviation: "NT", name: "Northwest Territories" },
    { abbreviation: "NS", name: "Nova Scotia" },
    { abbreviation: "NU", name: "Nunavut" },
    { abbreviation: "ON", name: "Ontario" },
    { abbreviation: "PE", name: "Prince Edward Island" },
    { abbreviation: "QC", name: "Quebec" },
    { abbreviation: "SK", name: "Saskatchewan" },
    { abbreviation: "YT", name: "Yukon Territory" }
  ]
};
var countries = [unitedStates, canada];
var countryDetailsByCode = {
  [unitedStates.abbreviation]: unitedStates,
  [canada.abbreviation]: canada
};
var usStates = unitedStates.regions.map((region) => region.abbreviation);
var canadianProvinces = canada.regions.map((region) => region.abbreviation);
function deriveCountryFromStateOrProvince(stateOrProvince) {
  var _a;
  return (_a = stateToCountryMap[stateOrProvince.trim().toLowerCase()]) != null ? _a : unitedStates.abbreviation;
}
var stateToCountryMap = {};
unitedStates.regions.reduce((accum, curr) => {
  accum[curr.abbreviation.toLowerCase()] = unitedStates.abbreviation;
  accum[curr.name.toLowerCase()] = unitedStates.abbreviation;
  return accum;
}, stateToCountryMap);
canada.regions.reduce((accum, curr) => {
  accum[curr.abbreviation.toLowerCase()] = canada.abbreviation;
  accum[curr.name.toLowerCase()] = canada.abbreviation;
  return accum;
}, stateToCountryMap);

// lib/address/split-address.ts
function splitAddress(address) {
  var _a, _b, _c, _d, _e, _f, _g;
  const isAPOBox = !!address.match(/ ?p\.?o\.? ?box ?/i);
  if (isAPOBox) {
    const firstComma = address.indexOf(",");
    const splitIndex = firstComma > -1 ? firstComma : address.length;
    const streetName2 = address.substring(0, splitIndex);
    const cityStatePostal2 = getCityStatePostal(address.substring(splitIndex));
    return {
      streetNumber: "",
      streetDirectionPrefix: "",
      streetName: streetName2,
      streetType: "",
      streetDirectionSuffix: "",
      unitNumber: "",
      buildingNumber: "",
      lotNumber: "",
      city: (_a = cityStatePostal2 == null ? void 0 : cityStatePostal2.city) != null ? _a : "",
      state: (_b = cityStatePostal2 == null ? void 0 : cityStatePostal2.state) != null ? _b : "",
      county: "",
      postalCode: (_c = cityStatePostal2 == null ? void 0 : cityStatePostal2.postalCode) != null ? _c : "",
      country: (cityStatePostal2 == null ? void 0 : cityStatePostal2.state) ? deriveCountryFromStateOrProvince(cityStatePostal2.state) : ""
    };
  }
  const streetNumber = getStreetNumber(address);
  const lot = getLotOrBldgNumber(address, lotNumberPrefixes);
  const bldg = getLotOrBldgNumber(address, buildingNumberPrefixes);
  const unit = getUnitNumber(address);
  const secondaryDesignatorStart = [lot.startIndex, bldg.startIndex, unit.startIndex].filter((n) => n > -1).sort()[0];
  const { value: streetDirectionNameType, endIndex: endStreet } = getStreetDirectionNameType(
    address.substring(0, secondaryDesignatorStart)
  );
  const addressLine1EndIndex = Math.max(endStreet, unit.endIndex, bldg.endIndex, lot.endIndex);
  const cityStatePostal = getCityStatePostal(address.substring(addressLine1EndIndex));
  let { match: streetDirectionPrefix, rest: woDirPrefix } = cutRegex(streetDirectionNameType, /^([NESW]+) /i);
  let { match: streetDirectionSuffix, rest: streetNameType } = cutRegex(woDirPrefix, / ([NESW]+)$/i);
  const landExtensionIndex = streetNameType.search(/ (ext\.?|extension)$/i);
  const streetTypeStartIndex = streetNameType.lastIndexOf(
    " ",
    // If the street name ends with " Ext" or " Extension", then we want to find the last
    // space before that part.
    landExtensionIndex >= 0 ? landExtensionIndex - 1 : void 0
  );
  const hasStreetType = streetTypeStartIndex > 0;
  let streetType = hasStreetType ? streetNameType.substring(streetTypeStartIndex + 1).trim() : "";
  let streetName = streetNameType.substring(0, hasStreetType ? streetTypeStartIndex : void 0).trim();
  const streetTypeStoleDigitsSuffix = streetType.match(/(\d+)$/);
  const digitsSuffix = (_d = streetTypeStoleDigitsSuffix == null ? void 0 : streetTypeStoleDigitsSuffix[1]) != null ? _d : "";
  if (digitsSuffix) {
    streetType = streetType.replace(digitsSuffix, "").trim();
    streetName = streetName + " " + digitsSuffix;
  }
  return {
    streetNumber,
    streetDirectionPrefix,
    streetName,
    streetType,
    streetDirectionSuffix,
    lotNumber: lot.value,
    buildingNumber: bldg.value,
    unitNumber: unit.value,
    city: (_e = cityStatePostal == null ? void 0 : cityStatePostal.city) != null ? _e : "",
    state: (_f = cityStatePostal == null ? void 0 : cityStatePostal.state) != null ? _f : "",
    county: "",
    postalCode: (_g = cityStatePostal == null ? void 0 : cityStatePostal.postalCode) != null ? _g : "",
    country: (cityStatePostal == null ? void 0 : cityStatePostal.state) ? deriveCountryFromStateOrProvince(cityStatePostal.state) : ""
  };
}
function getStreetNumber(address) {
  var _a, _b, _c;
  return (_c = (_b = (_a = address.match(/^(?<streetNumber>[0-9]+[0-9A-Z]*)\s+/)) == null ? void 0 : _a.groups) == null ? void 0 : _b.streetNumber) != null ? _c : "";
}
function getStreetDirectionNameType(address) {
  var _a, _b, _c;
  let match = address.match(/^(?<streetNumber>[0-9]+[0-9A-Z]*\s+)?(?<streetDirNameType>[^,]*)/);
  const value = (_b = (_a = match == null ? void 0 : match.groups) == null ? void 0 : _a.streetDirNameType) != null ? _b : "";
  const startIndex = (_c = match == null ? void 0 : match.index) != null ? _c : -1;
  const endIndex = match ? startIndex + value.length : -1;
  return { startIndex, endIndex, value };
}
var alphaNumeric = ":?\\s+#? *([a-z\\d]+)";
var buildingNumberPrefixes = [
  "Bldg\\.?" + alphaNumeric,
  "Building" + alphaNumeric,
  "Bld\\.?" + alphaNumeric
];
var lotNumberPrefixes = [
  "Lot" + alphaNumeric,
  "L(\\d+)"
];
var unitPrefixes = [
  "Apt\\.?" + alphaNumeric,
  "Apartment" + alphaNumeric,
  "Unit" + alphaNumeric,
  "#\\s*?([a-z\\d]+)",
  "Suite" + alphaNumeric,
  "Ste\\.?" + alphaNumeric,
  "Floor" + alphaNumeric,
  "Fl\\." + alphaNumeric,
  "Office" + alphaNumeric,
  "Ofc.?" + alphaNumeric,
  "Room" + alphaNumeric,
  "Rm\\.?" + alphaNumeric,
  "Department" + alphaNumeric,
  "Dep\\.?" + alphaNumeric,
  "Dept\\.?" + alphaNumeric,
  "Pier" + alphaNumeric
];
function getLotOrBldgNumber(address, prefixes) {
  for (const prefix of prefixes) {
    const match = address.match(new RegExp(`(?:[, ]${prefix})+`, "i"));
    if (!match || !match[1] || match.index == null)
      continue;
    return {
      startIndex: match.index,
      endIndex: match.index + match[0].length,
      value: match[1]
    };
  }
  return { startIndex: -1, endIndex: -1, value: "" };
}
function getUnitNumber(address, prefixes = unitPrefixes) {
  let matchIndices = prefixes.map((prefix) => {
    const match = address.match(new RegExp(`(?:[, ]${prefix})+`, "i"));
    if (!match || match.index == null)
      return null;
    return { start: match.index, end: match.index + match[0].length };
  }).filter(Boolean);
  if (!matchIndices.length)
    return { startIndex: -1, endIndex: -1, value: "" };
  const maxRangeIndices = matchIndices.reduce((indices, curr) => {
    if (!curr)
      return indices;
    if (curr.start < indices.start)
      indices.start = curr.start;
    if (curr.end > indices.end)
      indices.end = curr.end;
    return indices;
  });
  return {
    startIndex: maxRangeIndices.start,
    endIndex: maxRangeIndices.end,
    value: clean(address.substring(maxRangeIndices.start, maxRangeIndices.end))
  };
}
function takeDigitsFromString(arg) {
  var _a, _b;
  return (_b = arg && ((_a = arg.match(/\d/g)) == null ? void 0 : _a.join(""))) != null ? _b : "";
}
function getCityStatePostal(cityStatePostal) {
  const knownState = new RegExp(
    `(?<city>[\\w- ]+?)[\\s,]+(?<state>${everyStateOrProvince})[\\s\\n,]+(?<zip>[\\w- ]*)`
  );
  let match = cityStatePostal.match(knownState);
  if (match) {
    const { city, state, zip: zip2 } = match.groups;
    return { city: clean(city), state: clean(state), postalCode: zip2 };
  }
  const zipRegex = /[\w-]+$/;
  const zipMatch = cityStatePostal.match(zipRegex);
  let zip;
  if (zipMatch) {
    cityStatePostal = cityStatePostal.substring(0, zipMatch.index).trim();
    zip = zipMatch[0].trim();
  }
  const commaBreaks = cityStatePostal.split(",");
  const commaCount = commaBreaks.length - 1;
  if (commaCount === 1 || zip && commaCount === 2) {
    return {
      city: clean(commaBreaks[0]),
      state: clean(commaBreaks[1]),
      postalCode: zip
    };
  }
  if (commaCount > 2) {
    return {
      city: clean(commaBreaks[0]),
      state: clean(cityStatePostal.substring(cityStatePostal.indexOf(",") + 1)),
      postalCode: zip
    };
  }
  const whitespaceMatch = /\s/.exec(cityStatePostal);
  if (whitespaceMatch && whitespaceMatch.index) {
    const index = whitespaceMatch.index;
    return {
      city: clean(cityStatePostal.substring(0, index)),
      state: clean(cityStatePostal.substring(index)),
      postalCode: zip
    };
  }
  return null;
}
var everyStateOrProvince = [...unitedStates.regions, ...canada.regions].reduce((accum, region) => accum + "|" + region.abbreviation + "|" + region.name, "").substring(1);
function clean(str) {
  var _a;
  return (_a = str == null ? void 0 : str.replace(/,/g, " ").replace(/\s+/g, " ")) == null ? void 0 : _a.trim();
}
function cutRegex(str, regex) {
  var _a;
  const match = str.match(regex);
  if (!match || match.index == null)
    return { match: "", rest: str };
  const matchedStr = (_a = match[1]) != null ? _a : "";
  const cutStr = cut(str, { start: match.index, end: match.index + matchedStr.length });
  return { match: matchedStr, rest: cutStr };
}
function cut(str, args) {
  return str.substring(0, args.start) + str.substring(args.end + 1);
}

// lib/strings/capitalize.ts
function capitalize(str) {
  return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
}

// lib/strings/escape-html.ts
function escapeHtml(unescapedHtml) {
  var _a;
  if (!unescapedHtml)
    return unescapedHtml;
  return (_a = unescapedHtml.replace(/</g, "&lt;")) == null ? void 0 : _a.replace(/>/g, "&gt;");
}

// lib/strings/format.ts
import dateFormatter from "date-fns/format";

// lib/date-time.ts
function currentISODateTime() {
  return (/* @__PURE__ */ new Date()).toISOString();
}
var currentISOTime = currentISODateTime;
function today(args) {
  const d = /* @__PURE__ */ new Date();
  d.setHours(0, 0, 0, 0);
  if (args) {
    const { daysBefore = 0, daysAfter = 0 } = args;
    const days = daysAfter - daysBefore;
    d.setDate(d.getDate() + days);
  }
  return d;
}
function currentTimeZoneLong() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
var cachedTimeZoneShort;
function currentTimeZoneShort() {
  if (!cachedTimeZoneShort) {
    cachedTimeZoneShort = (/* @__PURE__ */ new Date()).toLocaleDateString(void 0, { day: "2-digit", timeZoneName: "short" }).substring(4);
  }
  return cachedTimeZoneShort;
}
function isISODateTime(str) {
  return str ? !!str.match(/\d{4}-\d{2}-\d{2}T\d\d:\d\d:\d\d(\.\d+)?(Z|(\+\d\d:\d\d))/) : false;
}
function dateOnly(isoDate) {
  if (!isoDate)
    return null;
  const tIndex = isoDate == null ? void 0 : isoDate.indexOf("T");
  return tIndex >= 0 ? isoDate == null ? void 0 : isoDate.substring(0, tIndex) : isoDate;
}
var plainDateFormats = [
  /^\d{4}[-/]\d{2}[-/]\d{2}$/,
  /^\d{1,2}[-/]\d{1,2}[-/]\d{4}$/,
  /^\d{1,2}[-/]\d{1,2}[-/]\d{2}$/
];
function ensureISODateInLocalTimeZoneMidnight(dateStr) {
  if (!dateStr)
    return dateStr;
  if (isISODateTime(dateStr))
    return dateStr;
  const isPlainDate = !!plainDateFormats.find((regex) => dateStr.match(regex));
  const dateObj = isPlainDate ? /* @__PURE__ */ new Date(dateStr + " 00:00:00") : new Date(dateStr);
  return isValidDate(dateObj) ? dateObj.toISOString() : "";
}
function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}
function ensureISODateAtUTCMidnight(dateStr) {
  if (!dateStr)
    return dateStr;
  const isPlainDate = !!plainDateFormats.find((regex) => dateStr.match(regex));
  if (!isPlainDate)
    return dateStr;
  const d = new Date(dateStr);
  d.setUTCHours(0, 0, 0, 0);
  return d.toISOString();
}
function prependZeroToTimeDigit(digit) {
  return digit < 10 ? "0" + digit : digit.toString();
}

// lib/strings/pluralize.ts
function pluralize(word, count) {
  const isArr = Array.isArray(word);
  const singular = isArr ? word[0] : word;
  const plural = isArr ? word[1] : singular + "s";
  return count == 1 ? singular : plural;
}

// lib/strings/format.ts
var currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
var fractionalCurrencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
function formatDate(date, formatString) {
  try {
    if (!date)
      return "";
    return dateFormatter(date, formatString);
  } catch (e) {
    return "";
  }
}
var MINUTE = 60;
var HOUR = MINUTE * 60;
var DAY = HOUR * 24;
var WEEK = DAY * 7;
var MONTH = DAY * 30;
var YEAR = DAY * 365;
function relativeTime(value, unit) {
  const val = Math.round(Math.abs(value));
  const article = unit === "hour" ? "an" : "a";
  if (value < 0 && val === 1)
    return `${article} ${unit} ago`;
  if (value < 0)
    return `${val} ${unit}s ago`;
  return `in ${val} ${pluralize(unit, val)}`;
}
var format = {
  /**
   * Turn a number into an american currency value, with two places
   * after the decimal and a dollar sign.
   */
  currency(value) {
    if (!value)
      return "";
    const num = Number(value);
    const isFractional = num % 1 !== 0;
    const formatter = isFractional ? fractionalCurrencyFormatter : currencyFormatter;
    return formatter.format(Number(value));
  },
  /**
   * Format a date into a string of an arbitrary format.
   * Default format is `03/01/23`. Format string options can be
   * found [here](https://date-fns.org/v1.29.0/docs/format).
   */
  date(d, formatString = "MM/dd/yy") {
    if (!d)
      return "";
    let date = new Date(d);
    if (typeof d === "string") {
      date = new Date(ensureISODateInLocalTimeZoneMidnight(d));
    } else {
      date = new Date(d);
    }
    return formatDate(date, formatString);
  },
  /** Format a date and time into a string `03/01/23 01:55 PM`. */
  dateAndTime(dateTime, options) {
    var _a, _b, _c;
    if (!dateTime)
      return "";
    const obj = dateTime;
    const isObjSignature = obj.hasOwnProperty("date") && obj.hasOwnProperty("time");
    let d;
    if (isObjSignature) {
      d = /* @__PURE__ */ new Date(((_a = obj.date) != null ? _a : "") + " " + ((_b = obj.time) != null ? _b : ""));
    } else {
      d = dateTime;
    }
    const defaultDateFormatString = "MM/dd/yy";
    const defaultTimeFormatString = "hh:mm a";
    const defaultDateAndTimeFormatString = defaultDateFormatString + " " + defaultTimeFormatString;
    const defaultFormatString = !isObjSignature ? defaultDateAndTimeFormatString : obj.date && obj.time ? defaultDateAndTimeFormatString : defaultDateFormatString;
    let formatted = format.date(d, (_c = options == null ? void 0 : options.formatString) != null ? _c : defaultFormatString);
    if (options == null ? void 0 : options.includeTimeZone)
      formatted += " " + currentTimeZoneShort();
    return formatted;
  },
  /**
   * Format a date and time into an unambiguous string
   * `March 1st, 2023 3:07 PM CDT`.
   */
  timeStamp(d) {
    if (!d)
      return "";
    const formatted = formatDate(new Date(d), "PPP p");
    return formatted ? formatted + " " + currentTimeZoneShort() : "";
  },
  /**
   * Turn a date value in to a relative string.
   * e.g. "just now", "yesterday", "in 4 weeks".
   */
  relativeDateTimeString(d) {
    if (!d)
      return "";
    const deltaSeconds = Math.round((new Date(d).valueOf() - Date.now()) / 1e3);
    const absDeltaSeconds = Math.abs(deltaSeconds);
    if (Number.isNaN(deltaSeconds))
      return "";
    if (absDeltaSeconds < 30 && deltaSeconds <= 0)
      return "just now";
    if (absDeltaSeconds < MINUTE)
      return relativeTime(deltaSeconds, "second");
    if (absDeltaSeconds < HOUR)
      return relativeTime(deltaSeconds / MINUTE, "minute");
    if (absDeltaSeconds < DAY)
      return relativeTime(deltaSeconds / HOUR, "hour");
    if (absDeltaSeconds < DAY * 2 && deltaSeconds < 0)
      return "yesterday";
    if (absDeltaSeconds < DAY * 2 && deltaSeconds > 0)
      return "tomorrow";
    if (absDeltaSeconds < WEEK)
      return relativeTime(deltaSeconds / DAY, "day");
    if (absDeltaSeconds < MONTH)
      return relativeTime(deltaSeconds / WEEK, "week");
    if (absDeltaSeconds < YEAR)
      return relativeTime(deltaSeconds / MONTH, "month");
    return relativeTime(deltaSeconds / YEAR, "year");
  },
  /** Determine the appropriate unit of time for a given number of milliseconds */
  duration(milliseconds) {
    if (milliseconds == null)
      return "";
    if (milliseconds < 1e3)
      return "less than a second";
    const seconds = Math.round(milliseconds / 1e3);
    if (seconds < 60)
      return `${seconds} ${pluralize("second", seconds)}`;
    const minutes = Math.round(seconds / 60);
    if (minutes < 60)
      return `${minutes} ${pluralize("minute", minutes)}`;
    const hours = Math.round(minutes / 60);
    if (hours < 24)
      return `${hours} ${pluralize("hour", hours)}`;
    const days = Math.round(hours / 24);
    if (days < 365)
      return `${days} ${pluralize("day", days)}`;
    const years = Math.round(days / 365);
    return `${years} ${pluralize("year", years)}`;
  },
  /** Format a plain phone number with dashes and parenthesis. */
  phone(phoneNumber) {
    if (phoneNumber === 0)
      return "0";
    if (!phoneNumber)
      return "";
    const strPhone = String(phoneNumber);
    const hasAreaCode = strPhone.length === 10;
    const areaCode = hasAreaCode ? strPhone.substring(0, 3) : "";
    const firstThree = hasAreaCode ? strPhone.substring(3, 6) : strPhone.substring(0, 3);
    const finalDigits = hasAreaCode ? strPhone.substring(6) : strPhone.substring(3);
    return hasAreaCode ? `(${areaCode}) ${firstThree}-${finalDigits}` : `${firstThree}-${finalDigits}`;
  },
  /**
   * Format a person's first and last name, dealing with one or the
   * other (or both) being missing.
   */
  name(person) {
    const { firstName, lastName } = person != null ? person : {};
    if (!firstName && !lastName)
      return "";
    if (lastName && !firstName)
      return lastName;
    if (firstName && !lastName)
      return firstName;
    return `${firstName} ${lastName}`;
  },
  /** Turn a number into a count of days. */
  days(days) {
    return days == null ? "" : days + " " + pluralize("day", days);
  },
  /**
   * Specifically targeted add address strings but should work for any input,
   * this function will capitalize the first letter of every word and lowercase
   * the remaining letters.
   *
   * Can handle pascal and camel case strings.
   */
  titleCase(value) {
    if (!value)
      return "";
    const isPascalOrCamelCase = /^[a-z]*([A-Z][a-z]*)+$/.test(value);
    if (isPascalOrCamelCase) {
      value = value.replace(/([A-Z])/g, " $1").trim();
    }
    const words = value.toLowerCase().split(" ");
    const titleCased = words.map((word) => {
      if (["us", "ne", "nw", "se", "sw", "po", "p.o", "p.o.", "po."].includes(word)) {
        return word.toUpperCase();
      }
      if (word.length >= 3 && /^mc/.test(word) || /^o\'/.test(word)) {
        return word.charAt(0).toUpperCase() + word.charAt(1).toLowerCase() + word.charAt(2).toUpperCase() + word.slice(3).toLowerCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return join(...titleCased);
  }
};
function join(...terms) {
  return terms.filter(Boolean).join(" ");
}

// lib/strings/make-name-possessive.ts
function makeNamePossessive(name) {
  if (!name)
    return "";
  const lastChar = name[name.length - 1];
  return lastChar === "s" ? `${name}'` : `${name}'s`;
}

// lib/strings/nth-last-index-of.ts
function nthLastIndexOf(toSearch, toFind, n) {
  if (toSearch == null)
    return -1;
  const hasObjectArg = typeof toSearch === "object";
  const _toFind = hasObjectArg ? toSearch.toFind : toFind;
  const _toSearch = hasObjectArg ? toSearch.toSearch : toSearch;
  let N = hasObjectArg ? toSearch.n : n;
  if (_toSearch == null || _toFind == null)
    return -1;
  if (!N || isNaN(N) || N <= 1)
    return _toSearch.lastIndexOf(_toFind);
  const recursiveIndex = nthLastIndexOf({ toFind: _toFind, toSearch: _toSearch, n: N - 1 });
  return _toSearch.lastIndexOf(_toFind, recursiveIndex - 1);
}

// lib/address/addr-property-finder.ts
var fallbackProperties = {
  streetNumber: ["streetNumber"],
  streetName: ["streetName"],
  streetDirectionPrefix: [
    "streetDirectionPrefix",
    "streetDirPrefix",
    "streetDirection",
    "direction"
  ],
  streetType: ["streetType", "streetSuffix"],
  streetDirectionSuffix: ["streetDirectionSuffix", "streetDirSuffix"],
  streetDirectionNameType: ["streetDirectionNameType"],
  addressLine1: ["address1", "addressLine1", "streetAddress"],
  lotNumber: ["lotNumber", "lot"],
  buildingNumber: ["buildingNumber", "building"],
  unitNumber: ["unitNumber", "unit"],
  city: ["city", "municipality"],
  county: ["county", "countyOrParish"],
  state: ["state", "stateProvince", "stateOrProvince", "province", "stateProvinceFullName"],
  postalCode: ["postalCode", "zipCode", "zip", "postal"],
  country: ["country"]
};
function getAddrProperty(key, address) {
  return fallback(address, fallbackProperties[key]);
}
function fallback(obj, keysInOrder) {
  var _a, _b;
  for (const key of keysInOrder) {
    if (!!obj[key])
      return obj[key];
    const camelCase = ((_a = key[0]) == null ? void 0 : _a.toLowerCase()) + key.slice(1);
    if (!!obj[camelCase])
      return obj[camelCase];
    const pascalCase = ((_b = key[0]) == null ? void 0 : _b.toUpperCase()) + key.slice(1);
    if (!!obj[pascalCase])
      return obj[pascalCase];
  }
  return "";
}

// lib/address/skyslope-address.ts
var SkySlopeAddress = class {
  get streetNumber() {
    return this.address.streetNumber || "";
  }
  get streetDirectionPrefix() {
    return this.address.streetDirectionPrefix || "";
  }
  get streetName() {
    return this.address.streetName || "";
  }
  get streetType() {
    return this.address.streetType || "";
  }
  get streetDirectionSuffix() {
    return this.address.streetDirectionSuffix || "";
  }
  /** The full street name; i.e. `addressLine1` without the street number; e.g. "SE Semi Circle Drive NW" */
  get streetDirectionNameType() {
    return format.titleCase(
      [this.streetDirectionPrefix, this.streetName, this.streetType, this.streetDirectionSuffix].filter(Boolean).join(" ")
    );
  }
  /** The first line of an address (no lot/bldg/unit number) */
  get addressLine1() {
    return join2(this.streetNumber, this.streetDirectionNameType);
  }
  /**
   * Lot number without any "Lot" or similar prefix.
   * Calling `.format...()` or `.lotBuildingUnitNumber` will include the "Bldg " prefix.
   */
  get lotNumber() {
    return this.address.lotNumber || "";
  }
  /**
   * Building number without any "Bldg" or similar prefix.
   * Calling `.format...()` or `.lotBuildingUnitNumber` will include the "Lot " prefix.
   */
  get buildingNumber() {
    return this.address.buildingNumber || "";
  }
  /**
   * The unit/apt/suite/floor/office/room number.
   * Will always have a prefix of some kind.
   */
  get unitNumber() {
    var _a;
    let unit = this.address.unitNumber;
    if (unit == null || !unit.length)
      return "";
    unit = (_a = String(unit)) == null ? void 0 : _a.trim();
    if (startsWithNumber(unit))
      unit = "#" + unit;
    return unit;
  }
  get lotBuildingUnitNumber() {
    let lot = this.address.lotNumber;
    if (lot && !lot.toLowerCase().startsWith("l"))
      lot = `Lot ${lot.trim()}`;
    let bldg = this.address.buildingNumber;
    if (bldg && !bldg.toLowerCase().startsWith("b"))
      bldg = `Bldg ${bldg.trim()}`;
    return join2(lot, bldg, this.unitNumber);
  }
  get city() {
    return format.titleCase(this.address.city) || "";
  }
  get county() {
    return this.address.county || "";
  }
  get state() {
    const state = this.address.state;
    if (state && state.length === 2)
      return state.toUpperCase();
    return state || "";
  }
  get postalCode() {
    return this.address.postalCode || "";
  }
  /**
   * Should be a two letter country code: US or CA, but if something
   * else was passed to the constructor, that will be returned here.
   * If no country was provided, it will be derived from the state.
   */
  get country() {
    const country = this.address.country;
    if (!country)
      return deriveCountryFromStateOrProvince(this.state);
    if (country.length === 2)
      return country.toUpperCase();
    return country;
  }
  /** @returns true if this address has all the minimum necessary parts to be a complete and valid address */
  get isValid() {
    return Boolean(
      this.address.streetNumber && this.address.streetName && this.address.streetType && this.address.city && this.address.state && this.address.postalCode
    );
  }
  constructor(address) {
    var _a;
    if (address == null) {
      throw new Error("Cannot instantiate SkySlopeAddress with nullish value");
    }
    if (typeof address === "string") {
      this.address = splitAddress(address);
    } else {
      this.address = {
        streetNumber: getAddrProperty("streetNumber", address),
        streetName: getAddrProperty("streetName", address),
        streetDirectionPrefix: getAddrProperty("streetDirectionPrefix", address),
        streetType: getAddrProperty("streetType", address),
        streetDirectionSuffix: getAddrProperty("streetDirectionSuffix", address),
        lotNumber: getAddrProperty("lotNumber", address),
        buildingNumber: getAddrProperty("buildingNumber", address),
        unitNumber: getAddrProperty("unitNumber", address),
        city: getAddrProperty("city", address),
        county: getAddrProperty("county", address),
        state: getAddrProperty("state", address),
        postalCode: getAddrProperty("postalCode", address),
        country: getAddrProperty("country", address)
      };
      const addressLine1 = getAddrProperty("addressLine1", address);
      if (addressLine1) {
        const split = splitAddress(addressLine1);
        mergeObjects(this.address, split);
      }
      const streetDirectionNameType = getAddrProperty("streetDirectionNameType", address);
      if (streetDirectionNameType) {
        const split = splitAddress(streetDirectionNameType);
        mergeObjects(this.address, split);
      }
      if (this.address.streetType && ((_a = this.address.streetName) == null ? void 0 : _a.includes(this.address.streetType))) {
        this.address.streetName = this.address.streetName.replace(this.address.streetType, "").trim();
      }
      if (this.address.streetName && !this.lotBuildingUnitNumber) {
        const split = splitAddress(this.address.streetName);
        if (split.lotNumber) {
          this.address.lotNumber = split.lotNumber;
          this.address.streetName = this.address.streetName.replace(split.lotNumber, "");
        }
        if (split.buildingNumber) {
          this.address.buildingNumber = split.buildingNumber;
          this.address.streetName = this.address.streetName.replace(split.buildingNumber, "");
        }
        if (split.unitNumber) {
          this.address.unitNumber = split.unitNumber;
          this.address.streetName = this.address.streetName.replace(split.unitNumber, "");
        }
      }
    }
  }
  /** Format into a string: first line of an address (including unit number) */
  formatShort() {
    const addressLine1 = this.addressLine1;
    if (!addressLine1)
      return "";
    const lotBldgUnit = this.lotBuildingUnitNumber;
    return lotBldgUnit ? `${addressLine1}, ${lotBldgUnit}` : addressLine1;
  }
  /** Format into a string: full address (but without the country) */
  formatLong() {
    let addr = [this.formatShort(), this.city, this.state].filter(Boolean).join(", ");
    if (this.postalCode)
      addr += " " + this.postalCode;
    return addr.trim();
  }
  /** Format an address into a string: first line of an address (including unit number). */
  static formatShort(address) {
    if (!address)
      return "";
    return new SkySlopeAddress(address).formatShort();
  }
  /** Format an address into a string: full address (but without the country). */
  static formatLong(address) {
    if (!address)
      return "";
    return new SkySlopeAddress(address).formatLong();
  }
  asPlainObject() {
    return {
      streetNumber: this.streetNumber,
      streetDirectionPrefix: this.streetDirectionPrefix,
      streetName: this.streetName,
      streetType: this.streetType,
      streetDirectionSuffix: this.streetDirectionSuffix,
      lotNumber: this.lotNumber,
      buildingNumber: this.buildingNumber,
      unitNumber: this.unitNumber,
      city: this.city,
      county: this.county,
      state: this.state,
      postalCode: this.postalCode,
      country: this.country
    };
  }
  asPlainUIObject() {
    return {
      addressLine1: this.addressLine1,
      unitNumber: this.lotBuildingUnitNumber,
      city: this.city,
      county: this.county,
      state: this.state,
      postalCode: this.postalCode,
      country: this.country
    };
  }
};
function join2(...terms) {
  return terms.filter(Boolean).join(" ");
}
function startsWithNumber(value) {
  return /^\d+/.test(value);
}
function mergeObjects(base, override, options) {
  const { force } = options || {};
  for (const key in override) {
    const overrideValue = override[key];
    if (overrideValue && (!base[key] || force))
      base[key] = overrideValue;
  }
}

// lib/browser/file-up-down-loading.ts
function downloadStringAsFile(args) {
  const { fileName, data } = args;
  const downloadUrl = window.URL.createObjectURL(new Blob([data]));
  const anchor = document.createElement("a");
  anchor.setAttribute("href", downloadUrl);
  anchor.setAttribute("download", fileName);
  anchor.click();
  window.URL.revokeObjectURL(downloadUrl);
}
function downloadJson(args) {
  const { fileName, data } = args;
  const dataStr = `data:text/json;charset=utf-8,${encodeURIComponent(
    JSON.stringify(data, null, 2)
  )}`;
  const finalFileName = fileName.endsWith(".json") ? fileName : `${fileName}.json`;
  const anchor = document.createElement("a");
  anchor == null ? void 0 : anchor.setAttribute("href", dataStr);
  anchor == null ? void 0 : anchor.setAttribute("download", finalFileName);
  anchor == null ? void 0 : anchor.click();
}
function printFile(url) {
  const iframe = document.createElement("iframe");
  iframe.src = url;
  iframe.style.display = "none";
  document.body.append(iframe);
  iframe.onload = () => {
    var _a;
    (_a = iframe.contentWindow) == null ? void 0 : _a.print();
  };
}
function pdfBase64ToUrl(base64string) {
  return new Promise((resolve, reject) => {
    try {
      const binary = atob(base64string.replace(/\s/g, ""));
      const len = binary.length;
      const buffer = new ArrayBuffer(len);
      const view = new Uint8Array(buffer);
      for (let i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
      }
      const blob = new Blob([view], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      resolve(url);
    } catch (error) {
      reject(error);
    }
  });
}
function fileToBase64Url(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
}
function base64UrlToBlob(urlToBase64EncodedString) {
  return fetch(urlToBase64EncodedString).then((res) => res.blob());
}

// lib/browser/query-string.ts
function queryStringify(queryObj, searchParams) {
  if (queryObj == null)
    return "";
  const _searchParams = searchParams || new URLSearchParams();
  Object.entries(queryObj).forEach(([name, value]) => {
    if (value == null)
      return;
    if (Array.isArray(value)) {
      if (value.length === 0)
        return;
      value.filter((x) => x != null).forEach((x) => _searchParams.append(name, String(x)));
    } else {
      _searchParams.append(name, String(value));
    }
  });
  return _searchParams.toString();
}
function getQueryParam(paramKey, defaultValue = null) {
  var _a;
  let params = null;
  if (window.location.search.indexOf(paramKey + "=") >= 0) {
    params = new URLSearchParams(window.location.search);
  } else if (window.location.hash.indexOf(paramKey + "=") >= 0) {
    params = new URLSearchParams("?" + window.location.hash.substring(1));
  }
  return (_a = params == null ? void 0 : params.get(paramKey)) != null ? _a : defaultValue;
}
function appendQueryParam(url, queryObj) {
  const urlObj = new URL(url);
  queryStringify(queryObj, urlObj.searchParams);
  return urlObj.toString();
}

// lib/browser/viewport-utils.ts
function resetViewport() {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.content = "width=device-width, minimum-scale=1.0, maximum-scale=1.0";
    viewport.content = "width=device-width, initial-scale=1";
  }
}

// lib/browser/window-utils.ts
function getIsSSR() {
  return typeof window === "undefined";
}

// lib/debugging/simplify-axios-objs.ts
function simplifyAxiosError(err) {
  var _a, _b, _c, _d;
  return {
    code: err.code,
    message: err.message,
    request: {
      token: (() => {
        var _a2, _b2;
        const token = (_b2 = (_a2 = err == null ? void 0 : err.config) == null ? void 0 : _a2.headers) == null ? void 0 : _b2.Authorization;
        return token ? token.slice(0, 30) + "..." : token;
      })(),
      baseURL: (_a = err.config) == null ? void 0 : _a.baseURL,
      url: (_b = err.config) == null ? void 0 : _b.url,
      params: (_c = err.config) == null ? void 0 : _c.params,
      data: (_d = err.config) == null ? void 0 : _d.data
    },
    response: simplifyAxiosResponse(err.response)
  };
}
function simplifyAxiosResponse(res) {
  var _a, _b;
  return res && {
    status: res.status,
    statusText: res.statusText,
    headers: res.headers,
    baseURL: (_a = res.config) == null ? void 0 : _a.baseURL,
    url: (_b = res.config) == null ? void 0 : _b.url,
    data: res.data
  };
}

// lib/translation/init-translation.ts
function initTranslation(genericDict, createPageSpecificDict) {
  const pageSpecificDict = createPageSpecificDict == null ? void 0 : createPageSpecificDict((key) => key);
  const fullDict = { ...genericDict, ...pageSpecificDict };
  function translate(key) {
    var _a;
    const val = (_a = fullDict[key]) != null ? _a : "";
    const isLinkedKey = !!genericDict[val];
    return isLinkedKey ? translate(val) : val;
  }
  translate.dictionary = fullDict;
  translate.keys = Object.keys(fullDict);
  return translate;
}

// lib/app-urls-by-env.ts
var appUrlsByEnv = {
  integ: {
    env: "integ",
    breezeUrl: "https://integ-breeze.skyslope.com",
    ds3Url: "https://integ-send.skyslope.com/envelopes",
    formsUrl: "https://integ-forms.skyslope.com",
    offersUrl: "https://integ-offers.skyslope.com",
    primeUrl: "https://integ.skyslope.com",
    booksUrl: "https://zipi-dev.skyslope.com/login/skyslope-callback"
  },
  staging: {
    env: "staging",
    breezeUrl: "https://staging-breeze.skyslope.com",
    ds3Url: "https://staging-send.skyslope.com/envelopes",
    formsUrl: "https://staging-forms.skyslope.com",
    offersUrl: "https://staging-offers.skyslope.com",
    primeUrl: "https://staging.skyslope.com",
    booksUrl: "https://books-stage.skyslope.com/login/skyslope-callback"
  },
  prod: {
    env: "prod",
    breezeUrl: "https://breeze.skyslope.com",
    ds3Url: "https://send.skyslope.com/envelopes",
    formsUrl: "https://forms.skyslope.com",
    offersUrl: "https://offers.skyslope.com",
    primeUrl: "https://app.skyslope.com",
    booksUrl: "https://books.skyslope.com/login/skyslope-callback"
  }
};

// lib/arrays.ts
function ensureArray(arrayIsh) {
  return arrayIsh == null ? [] : Array.isArray(arrayIsh) ? arrayIsh : [arrayIsh];
}
function distinct(arr) {
  if (!arr)
    return [];
  return arr.filter((value, index, self) => self.indexOf(value) === index);
}
function makeDistinctArrays(...arrays) {
  const nonNullArrays = arrays.filter(Boolean).reverse();
  if (nonNullArrays.length === 0)
    return [];
  const uniqueKeys = {};
  nonNullArrays.forEach((arr, indexOfArray) => {
    arr.forEach((item) => {
      if (item)
        uniqueKeys[item] = indexOfArray;
    });
  });
  const returnArrays = Array(nonNullArrays.length).fill(null).map(() => []);
  Object.entries(uniqueKeys).forEach(
    ([item, indexOfArray]) => {
      var _a;
      return (_a = returnArrays[indexOfArray]) == null ? void 0 : _a.push(item);
    }
  );
  return returnArrays.reverse();
}
function bisect(array, callbackFn) {
  const map = nSect(array, (item) => !!callbackFn(item));
  return [map.get(true) || [], map.get(false) || []];
}
function nSect(array, callbackFn) {
  const map = /* @__PURE__ */ new Map();
  array.forEach((value) => {
    const key = callbackFn(value);
    if (!map.has(key))
      map.set(key, []);
    map.get(key).push(value);
  });
  return map;
}
function batch(array, batchSize = 5) {
  const localArray = [...array];
  const result = [];
  while (localArray.length > 0) {
    result.push(localArray.splice(0, batchSize));
  }
  return result;
}
function objectKeys(object) {
  return Object.keys(object);
}
function groupBy(array, getGroupKey) {
  return array.reduce((acc, item) => {
    const groupKey = getGroupKey(item);
    if (groupKey == null)
      return acc;
    if (!acc[groupKey])
      acc[groupKey] = [];
    acc[groupKey].push(item);
    return acc;
  }, {});
}

// lib/colors.ts
var colors = {
  grey: {
    50: "#fafcff",
    100: "#f4f8fc",
    200: "#ebf1f6",
    300: "#dee5ed",
    400: "#cad5e0",
    500: "#afbecd",
    600: "#8ba0b4",
    700: "#637d97",
    800: "#3f5b77",
    900: "#0a2642"
  },
  purple: {
    50: "#f0f2ff",
    100: "#e2e6ff",
    200: "#cbcdff",
    300: "#a0a4fd",
    400: "#6f75ff",
    500: "#533db1"
  },
  blue: {
    50: "#e1f1ff",
    100: "#b7dcff",
    200: "#87c6ff",
    300: "#4eafff",
    400: "#079eff",
    500: "#008dff",
    600: "#007eff",
    700: "#006bed",
    800: "#0059da",
    900: "#1537bb",
    powder: "#6eadfe"
  },
  teal: {
    50: "#c7f3f8",
    100: "#80deea",
    200: "#4dd0e1",
    300: "#00bcd4",
    400: "#00acc1",
    500: "#0097a7",
    electric: "#00dfec"
  },
  seagreen: {
    50: "#a7e9db",
    100: "#67d3bd",
    200: "#3cc5b3"
  },
  green: {
    50: "#bff5d3",
    100: "#83e3ab",
    200: "#65cd97",
    300: "#47b676",
    400: "#3ba06c",
    500: "#328755"
  },
  yellow: {
    50: "#fdf7d0",
    100: "#fce984",
    200: "#fcca4e",
    300: "#ffab00"
  },
  orange: {
    50: "#f78812",
    100: "#ff6702",
    200: "#fa4515"
  },
  pink: {
    50: "#ffbbc7",
    100: "#f787a9",
    200: "#ef538b"
  },
  red: {
    50: "#fef0f2",
    100: "#fca0a2",
    200: "#ff7679",
    300: "#e93b3f",
    400: "#d20004",
    500: "#bb000a"
  }
};

// lib/math.ts
function clamp(num, args) {
  const { min, max } = args;
  return Math.min(Math.max(num, min), max);
}
function round(num, decimals = 0) {
  const factor = Math.pow(10, decimals);
  return Math.round((num + Number.EPSILON) * factor) / factor;
}

// lib/objects.ts
function pickKeysFromObject(obj, keys) {
  const newObj = {};
  keys.forEach((key) => newObj[key] = obj[key]);
  return newObj;
}
function pick(obj, ...keys) {
  return keys.reduce((acc, key) => {
    const k = key;
    if (k && obj[k] !== void 0)
      acc[k] = obj[k];
    return acc;
  }, {});
}

// lib/util-types.ts
function assertNever(x, message = "Unexpected value. Should have been never") {
  throw new Error(message + ": " + x);
}
export {
  SkySlopeAddress,
  appUrlsByEnv,
  appendQueryParam,
  assertNever,
  base64UrlToBlob,
  batch,
  bisect,
  canada,
  canadianProvinces,
  capitalize,
  clamp,
  colors,
  countries,
  countryDetailsByCode,
  currentISODateTime,
  currentISOTime,
  currentTimeZoneLong,
  currentTimeZoneShort,
  dateOnly,
  deriveCountryFromStateOrProvince,
  distinct,
  downloadJson,
  downloadStringAsFile,
  ensureArray,
  ensureISODateAtUTCMidnight,
  ensureISODateInLocalTimeZoneMidnight,
  escapeHtml,
  fileToBase64Url,
  format,
  getIsSSR,
  getQueryParam,
  groupBy,
  initTranslation,
  isISODateTime,
  makeDistinctArrays,
  makeNamePossessive,
  nSect,
  nthLastIndexOf,
  objectKeys,
  pdfBase64ToUrl,
  pick,
  pickKeysFromObject,
  pluralize,
  prependZeroToTimeDigit,
  printFile,
  queryStringify,
  resetViewport,
  round,
  simplifyAxiosError,
  simplifyAxiosResponse,
  takeDigitsFromString,
  today,
  unitedStates,
  usStates
};
